// extracted by mini-css-extract-plugin
export default {"form-upload__loading-text-container":"styles_form-upload__loading-text-container__Yd0ua","form-upload__loading-text":"styles_form-upload__loading-text__lEH7G"};